import { getGpxs } from "../../helpers/getGpxs";
import { parseStyle } from "./parseStyle";

//GET data and styles from GPX trax
export async function getX(fileName: string) {
  return await getGpxs(fileName).then(data => {
    const style = parseStyle;
    return {
      gpx: data,
      style: style
    };
  });
}
